import {
  inlineHTMLToJSON,
  inlineJSONToHTML,
} from "../convert";

import {
  deepFindByUID,
  generateNode,
  insertAfterNodeByUID,
  modifyNodeValueByUIDAndKey,
} from "../doc_helpers";

import {
  inlineJSONBeforeIndex,
  inlineJSONAfterIndex,
} from "../inline_json";

export function handleNewLineInsert<DocContent extends PossibleContent>(
  modifyContent: (modifyFunction: ModifyFunction<DocContent>) => void,
  setCurrentlyEditing: (currentSelection: CurrentlyEditing | undefined) => void,
  currentlyEditingOverride?: CurrentlyEditing,
) {
  modifyContent((json, currentlyEditing) => {
    const currentSelection = currentlyEditingOverride || currentlyEditing;
    if (!currentSelection || !currentSelection?.range) { return json; }

    const currentlyEditingNode = deepFindByUID(json, currentSelection.uid);
    if (!currentlyEditingNode) { return json; }

    if (currentlyEditingNode.type === "section" && currentSelection.key === "title") { return json; } // TODO Make section/title key test better

    const newNode = generateNode(currentlyEditingNode.type);

    if (!("content" in newNode)) { return json; }

    const node = deepFindByUID(json, currentSelection.uid);

    if (!node) { return json; }

    const content = (node as any)[currentSelection.key];

    const inlineText = inlineHTMLToJSON(content);

    const textBefore = inlineJSONBeforeIndex(inlineText, currentSelection.range.start);
    const textAfter = inlineJSONAfterIndex(inlineText, currentSelection.range.end);

    let newJSON = json;

    newJSON = modifyNodeValueByUIDAndKey(json, currentSelection.uid, currentSelection.key,  (inlineHTML: InlineHtmlContent) => {
      return inlineJSONToHTML(textBefore);
    });

    newNode.content = inlineJSONToHTML(textAfter);
    newJSON = insertAfterNodeByUID(newJSON, currentSelection.uid, newNode);

    setCurrentlyEditing({uid: newNode.uid, range: {start: 0, end: 0}, key: "content"});

    return newJSON;
  });
}
